/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Fact2Inputs */

const en_dr_room_fact2 = /** @type {(inputs: Dr_Room_Fact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ambiguous requirements cut coding-agent Pass@1 by 35–52% (Wu et al. 2024, HumanEvalComm).`)
};

const id_dr_room_fact2 = /** @type {(inputs: Dr_Room_Fact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebutuhan yang ambigu menurunkan Pass@1 agen coding 35–52% (Wu dkk. 2024, HumanEvalComm).`)
};

/**
* | output |
* | --- |
* | "Ambiguous requirements cut coding-agent Pass@1 by 35–52% (Wu et al. 2024, HumanEvalComm)." |
*
* @param {Dr_Room_Fact2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_fact2 = /** @type {((inputs?: Dr_Room_Fact2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Fact2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_fact2(inputs)
	return en_dr_room_fact2(inputs)
});